import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { ICategoryState } from '../types';
import { sectorService } from 'features/settings/topology/api/sector.service';

interface CategoryFormProps {
  category: ICategoryState;
  onSubmit: any;
}
function CategoryForm(props: CategoryFormProps) {
  const { t } = useTranslation();
  const { category, onSubmit } = props;
  const [sectors, setSectors] = useState<Option[]>([]);

  useEffect(() => {
    sectorService.getAllBaseInformation().then(setSectors);
  }, []);

  const initialSector =
    category && category.sector !== undefined && category.sector !== null && category.sector !== ''
      ? category.sector
      : undefined;

  return (
    <>
      {category && (
        <EnhancedForm
          onSubmit={onSubmit}
          edit={!!category.id}
          initialValues={{
            code: category.code ?? '',
            description: category.description ?? '',
            sector: initialSector
          }}
          autoStyleLayout={true}
          columns={3}>
          <IdentityField
            name="code"
            component={TextFieldAdapter}
            initialValue={category.code}
            label={t('global.code')}
            placeholder={t('global.code')}
            type="text"
          />
          <IdentityField
            gridSpan={2}
            name="description"
            component={TextFieldAdapter}
            initialValue={category.description}
            label={t('global.description')}
            placeholder={t('global.description')}
            type="text"
          />
          {sectors && (
            <IdentityField
              gridSpan={3}
              name="sector"
              component={AutocompleteAdapter}
              initValue={sectors.find((s) => s.id === category.sector)}
              options={sectors}
              label={t('global.sector')}
              type="text"
              autoSelect={false}
            />
          )}
        </EnhancedForm>
      )}
    </>
  );
}

export default CategoryForm;
